module.exports = __webpack_public_path__ + "static/media/header-green-bg.39383b9d.svg";